import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Header */}
      <section className="py-16 px-6 md:px-12 lg:px-24 border-b bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-semibold text-[#0f3e3e] mb-2">
            Privacy Policy
          </h1>
          <p className="text-sm text-muted-foreground mb-4">
            Last Updated: 01 January 2025
          </p>
          <p className="text-muted-foreground">
            Safety Training Institute (“we”, “our”, “us”) is committed to
            protecting the privacy of our students, visitors, and users of our
            website.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 px-6 md:px-12 lg:px-24">
        <div className="max-w-4xl mx-auto space-y-8 text-muted-foreground leading-relaxed">

          <p>
            This Privacy Policy explains how we collect, use, disclose, and
            safeguard your information when you visit our website or enroll in
            our training programs.
          </p>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              1. Information We Collect
            </h2>
            <p>We may collect the following types of information:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Personal details such as name, date of birth, address, email, and mobile number</li>
              <li>Identification details such as Aadhaar or ID proof (if required for certification)</li>
              <li>Course enrollment and training completion details</li>
              <li>Payment and transaction information</li>
              <li>Certificate and verification-related information</li>
              <li>Technical data such as IP address, browser type, and device information</li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              2. How We Use Your Information
            </h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Process course registrations and payments</li>
              <li>Provide training services and learning materials</li>
              <li>Issue, verify, and allow download of certificates</li>
              <li>Communicate important course updates and notifications</li>
              <li>Improve our website, services, and user experience</li>
              <li>Comply with legal and regulatory requirements</li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              3. Certificate Data & Verification
            </h2>
            <p>
              Certificate details generated after course completion are stored
              securely. Certificates may contain student name, course title,
              enrollment number, and completion date.
            </p>
            <p className="mt-2">
              Verification may be provided through QR codes or online
              verification pages.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              4. Data Sharing & Disclosure
            </h2>
            <p>We do not sell or rent your personal information.</p>
            <p className="mt-2">Data may be shared only:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>With authorized institute staff for academic and administrative purposes</li>
              <li>With payment gateways for secure transaction processing</li>
              <li>When required by law or government authorities</li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              5. Data Security
            </h2>
            <p>
              We implement reasonable technical and administrative security
              measures to protect your personal data from unauthorized access,
              misuse, or disclosure.
            </p>
            <p className="mt-2">
              However, no online transmission or storage system is 100% secure.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              6. Cookies
            </h2>
            <p>
              Our website may use cookies to enhance user experience and analyze
              website traffic. You can choose to disable cookies through your
              browser settings.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              7. User Rights
            </h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Request access to your personal information</li>
              <li>Request correction of incorrect or outdated data</li>
              <li>Request deletion of data (subject to legal requirements)</li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              8. Third-Party Links
            </h2>
            <p>
              Our website may contain links to third-party websites. We are not
              responsible for the privacy practices or content of those
              websites.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              9. Changes to This Policy
            </h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes
              will be posted on this page with an updated revision date.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              10. Contact Us
            </h2>
            <p><strong>Institute Name:</strong> Safety Training Institute</p>
            <p><strong>Location:</strong> Bahanaga, Balasore, Odisha – 756042</p>
            <p><strong>Phone:</strong> 8280607556 / 9938232920</p>
            <p>
              <strong>Email:</strong>{" "}
              <a
                href="mailto:info@safetytraininginstitute.org.in"
                className="text-[#0f3e3e] font-medium"
              >
                info@safetytraininginstitute.org.in
              </a>
            </p>
            <p>
              <strong>Website:</strong>{" "}
              <a
                href="https://www.safetytraininginstitute.org.in"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#0f3e3e] font-medium"
              >
                www.safetytraininginstitute.org.in
              </a>
            </p>
          </div>

        </div>
      </section>
      <Footer/>
    </div>
  );
};

export default PrivacyPolicy;